import { Selectbutton } from '@/shared/ui/Selectbutton'
import { useCommonCodes } from '@/shared/lib/codes'
import { figmaLabel, sortByFigma } from '@/shared/lib/figmaLabel'
import type { ProblemNewDraft } from '@/public/features/problem/types'
import { CATEGORY_MAX } from '@/public/features/problem/constants/problemNew'

export function StepCategory({ draft }: { draft: ProblemNewDraft }) {
  const categories = useCommonCodes('category')
  const isFull = draft.categoryCodes.length >= CATEGORY_MAX

  return (
    <section className="flex flex-col gap-8">
      <div className="flex flex-col gap-[5px]">
        <p className="m-0 text-headline-xs font-normal tracking-[-0.1px] text-black-800">
          어떤 분야인가요?
        </p>
        <p className="m-0 text-body-md font-normal text-black-200">
          문제와 가까운 분야를 최대 {CATEGORY_MAX}개까지 선택해 주세요.
        </p>
      </div>
      <div className="flex flex-wrap content-start gap-3 [&>.ui-selectbutton]:min-w-[150px] [&>.ui-selectbutton]:flex-[1_0_0] [&>.ui-selectbutton]:whitespace-nowrap">
        {sortByFigma(categories.data ?? []).map((c) => (
          <Selectbutton
            key={c.code}
            size="lg"
            label={figmaLabel(c.code, c.label)}
            isOn={draft.categoryCodes.includes(c.code)}
            isBlocked={isFull}
            onSelect={() => draft.toggleCategory(c.code)}
          />
        ))}
      </div>
    </section>
  )
}
